import React from "react";
import { API } from "../../API";
import { NewPhysicianParams, PatientId } from "../../messages";
import { AddPhysicianScreen } from "./AddPhysicianScreen";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { allPhysiciansQueryKey, primaryPhysicianQueryKey } from "./physician.queryKeys";

export function AddPhysicianActivity(props: {
  api: API;
  patientId: PatientId;
  onClickGoBack: () => void;
}) {
  const queryClient = useQueryClient();
  const addNewPhysicianMutation = useMutation({
    mutationFn: (newPhysician: NewPhysicianParams) => {
      return props.api.addNewPhysician(props.patientId, newPhysician);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(primaryPhysicianQueryKey(props.patientId));
      queryClient.invalidateQueries(allPhysiciansQueryKey(props.patientId));
      props.onClickGoBack();
    },
  });

  const handleAddNewPhysician = (params: NewPhysicianParams) => {
    addNewPhysicianMutation.mutate(params);
  };

  return (
    <AddPhysicianScreen
      isLoading={addNewPhysicianMutation.isLoading}
      onClickGoBack={props.onClickGoBack}
      onClickAddPhysician={handleAddNewPhysician}
    />
  );
}
